import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  useAnalyticsAnonymousId,
  useAnalyticsUserId,
} from "~/components/Analytics/analyticsHooks";
import {
  RequestDemoFormSchema,
  createDemoFormSchema,
} from "~/lib/shared/schemas/requestDemoSchema";

export type UseRequestDemoForm = {
  defaultFormValues?: Partial<RequestDemoFormSchema>;
  /** When true, force turnstileResult to be defined on the form before submitting */
  enableTurnstile: boolean;
};

const defaultProps: UseRequestDemoForm = {
  enableTurnstile: true,
};

export const useRequestDemoForm = ({
  defaultFormValues,
  enableTurnstile,
}: UseRequestDemoForm = defaultProps) => {
  const analyticsUserId = useAnalyticsUserId();
  const analyticsAnonymousId = useAnalyticsAnonymousId();

  const { getValues, setValue, ...rest } = useForm<RequestDemoFormSchema>({
    resolver: zodResolver(createDemoFormSchema(enableTurnstile)),
    defaultValues: { analyticsUserId: null, ...defaultFormValues },
    mode: "onBlur",
  });

  useEffect(() => {
    if (analyticsUserId) {
      setValue("analyticsUserId", analyticsUserId);
    }
    if (analyticsAnonymousId) {
      setValue("analyticsAnonymousId", analyticsAnonymousId);
    }
  }, [analyticsAnonymousId, analyticsUserId, setValue]);

  return {
    getValues,
    setValue,
    ...rest,
  };
};
